'use client';

import { freddyTheme, IconButton } from '@coolblue-development/freddy';
import selectOptionTrigger from '@coolblue-development/ga4-events/triggers/InternalIcons/selectOptionTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ReactElement, ReactNode } from 'react';

import { openInternalPopup } from '../../utils/internalPopup';

export default function VanessaMainIconButton({
  iconLabel,
  url,
  index,
  totalIndices,
  children
}: {
  iconLabel: string;
  url: string;
  index: number;
  totalIndices: number;
  children: ReactNode;
}): ReactElement {
  const { trackEvent } = useAnalytics();

  return (
    <IconButton
      aria-label={iconLabel}
      size='small'
      onClick={() => {
        trackEvent(
          selectOptionTrigger({
            sub_feature: 'vanessa',
            index: index,
            total_indices: totalIndices,
            selection_type: 'selected',
            option_name: 'vanessa',
            attribute: 'vanessa'
          })
        );
        openInternalPopup(url);
      }}
      sx={{
        padding: '0.6rem',
        svg: {
          width: freddyTheme.spacing[500],
          height: freddyTheme.spacing[500]
        }
      }}
    >
      {children}
    </IconButton>
  );
}
